import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  templateUrl: 'general-programmer-notes-dialog.component.html',
  styleUrls: ['general-programmer-notes-dialog.component.scss']
})
export class GeneralProgrammerNotesDialogComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<GeneralProgrammerNotesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { programmerNotes: string }
  ) {}

  ngOnInit(): void {
    this.dialogRef.addPanelClass('eiq-progNotes-dialog');
  }

  onSave(): void {
    this.dialogRef.close(this.data.programmerNotes);
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
